export function SchemaVersion()
{
	let val = process.env.VUE_APP_SCHEMA_VERSION;
	if (val) return parseInt(val);
	return 0;
}

export function IsSchemaCompatible(schemaVersion : string)
{
	let schema = parseInt(schemaVersion);
	return (schema == 1 || schema == 2);
}

export function GetSchemaDisplayVersion(schemaVersion : string)
{
	let schema = parseInt(schemaVersion);
	if (schema == 1 || schema == 2)
		return "2";
	
	return schemaVersion;
}

export function IsEmbedBuild()
{
	return process.env.VUE_APP_EMBED != undefined;
}